<template>
  <div class="container login-page">
    <Menu v-if="!accessToken">
      <template #heading>
        <h1>Account</h1>
      </template>
      <template #content>
        <template v-if="!showForgottenPassword">
          <div class="container">
            <Tabs>
              <Tab name="Login to your account">
                <SingleSignOn />
                <LoginForm @success="handleLoginSuccess" />
                <div class="forgotten-password-button">
                  <Button
                    type="button"
                    full-width
                    theme="outline"
                    @click="showForgottenPassword = true"
                  >
                    Forgotten password?
                  </Button>
                </div>
              </Tab>
              <Tab name="New customer?">
                <RegisterForm @success="handleRegisterSuccess" />
              </Tab>
            </Tabs>
          </div>
        </template>

        <AccountRecovery v-if="showForgottenPassword" />
      </template>
    </Menu>

    <Menu v-else>
      <template #heading>
        <h1>Account</h1>
      </template>
      <template #content>
        <div class="container">
          <p class="u__text-align--center">Please wait while we log you in</p>
          <Spinner />
        </div>
      </template>
    </Menu>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapActions, mapState } from "vuex";

import LoginForm from "@/components/account/LoginForm.vue";
import RegisterForm from "@/components/account/RegisterForm.vue";
import Button from "@/components/Button.vue";
import Menu from "@/components/Menu";
import SingleSignOn from "@/components/SingleSignOn.vue";
import Spinner from "@/components/Spinner.vue";
import Tab from "@/components/Tab.vue";
import Tabs from "@/components/Tabs.vue";
const AccountRecovery = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "AccountRecovery" */ "@/components/account/AccountRecovery.vue"
  )
);

export default {
  name: "LoginPage",
  components: {
    LoginForm,
    RegisterForm,
    AccountRecovery,
    SingleSignOn,
    Tabs,
    Tab,
    Spinner,
    Button,
    Menu,
  },
  data() {
    return {
      showForgottenPassword: false,
      accessToken: null,
    };
  },
  computed: {
    ...mapState("auth", ["multipassAccount"]),
  },
  async created() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    this.accessToken = params.token;
    const returnUrl = params.return_url;

    if (this.accessToken) {
      try {
        const resp = await this.attemptSSOLogin({
          accessToken: this.accessToken,
          returnUrl,
        });

        if (resp) {
          window.location.href = this.multipassAccount.url;
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  methods: {
    ...mapActions("auth", ["setCustomerAccessToken", "attemptSSOLogin"]),
    handleLoginSuccess() {
      window.location.href = this.multipassAccount.url;
    },
    handleRegisterSuccess() {
      window.location.href = this.multipassAccount.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  width: 100%;
  max-width: 500px;
  margin: 30px auto 0;
}

.forgotten-password-button {
  margin-top: 10px;
}
</style>
